// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3oQlV","errors":"Errors_errors__HK8FC"};